
export class Template {
	public templateID: string;
	public templateName: string;
	public templateJSON: string;
	// Designer templates: exported HTML sent for server-side substitution-field validation (not persisted).
	// HTML (expert mode) templates: this is the template itself and is persisted; templateJSON is null.
	public templateHtml: string;
	// 1 = Designer (Unlayer), 2 = HTML (expert mode). See EditorType in email-html-import.ts.
	public editorTypeID: number = 1;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}